import React from 'react';

const Radio = (props) => {
    return (
        <label style = {{ position: 'relative', opacity: props.disabled ? 0.3 : 1 }} className={`${props.lblClass} ${props.checked?'active':''} ${props.disabled?'txtDisabled':''}`}>
            <input
                type = 'radio'
                value = { props.value }
                checked = { props.checked }
                onChange = { props.handleChange }
                style = {{ opacity: 0, margin: '0 10px' }}
                name = { props.name }
                className={props.className}
            />
            { props.showValue }
            <span style = {{
                position: 'absolute',
                left: '7px',
                top: '4px',
                width: '15px',
                height: '15px',
                border: '2px solid ' + window.color['searchBoxBgColor'],
                borderRadius: '50%'
            }} className={props.spanOuterClass}></span>
            <span style = {{
                position: 'absolute',
                left: '11px',
                top: '8px',
                width: '10px',
                height: '10px',
                background: props.checked ? window.color['searchBoxBgColor'] : '#fff',
                borderRadius: '50%',
                zIndex: 2
            }} className={props.spanInnerClass}></span>
        </label>
    );
}

export default Radio;


// WEBPACK FOOTER //
// ./src/components/common/radio.js